import { IManager } from './i-manager';
import { ISector } from './i-sector';

export interface IRelatedManager {
  manager: IManager;
  selectedSector: ISector;
}

export class RelatedManager implements IRelatedManager {
  constructor(
    public manager: IManager,
    public selectedSector: ISector,
  ) {}
}
